import qs from "qs";
import http from "../http";

function createProject(payload) {
  return http("POST", `${window.API_URL}/project`, payload);
}

function updateProject(payload) {
  return http("PUT", `${window.API_URL}/project`, payload);
}

function updateProjectStatus(payload) {
  return http("PUT", `${window.API_URL}/project`, payload);
}

function deleteProjects(payload) {
  return http("DELETE", `${window.API_URL}/project`, payload);
}

function getProjectDetail(payload) {
  return http("GET", `${window.API_URL}/projects/${payload.id}`);
}

function getProjectModifyDetail(payload) {
  return http("GET", `${window.API_URL}/projects/${payload.id}/modify`);
}

function getProjectTasks(payload) {
  return http("GET", `${window.API_URL}/project/task?${qs.stringify(payload)}`);
}

function getProjectPeoples(payload) {
  return http(
    "GET",
    `${window.API_URL}/project/people?${qs.stringify(payload)}`
  );
}

function isProjectWorkResume(payload) {
  return http(
    "GET",
    `${window.API_URL}/project/${payload.id}/isProjectWorkResume`
  );
}

function getProjectWorkedCount(payload) {
  return http(
    "GET",
    `${window.API_URL}/project/${payload.id}/projectWorkedCount?targetWorkloadType=${payload.targetWorkloadType}`
  );
}

function updateProjectTargetWorkload(payload) {
  const id = payload.id;
  return http("PUT", `${window.API_URL}/project/${id}/targetWorkload`, payload);
}

function getContractTemplates(payload) {
  return http(
    "GET",
    `${window.API_URL}/contract-templates/${payload.templateId}`
  );
}

export default {
  getProjectDetail,
  getProjectModifyDetail,
  createProject,
  updateProject,
  deleteProjects,
  getProjectTasks,
  getProjectPeoples,
  updateProjectStatus,
  isProjectWorkResume,
  getProjectWorkedCount,
  updateProjectTargetWorkload,
  getContractTemplates,
};
